import React from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const testimonials = [
  {
    id: 1,
    name: 'Alex C.',
    role: 'High School Junior',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_161280329-1763301853399.png",
    avatarAlt: 'Professional headshot of young male student with confident smile wearing casual blue shirt',
    content: 'BardPlay turned Shakespeare from my worst subject into my favorite! The gamification keeps me hooked, and I actually understand what\'s happening in the plays now. My grades went from C\'s to A\'s in just one semester!',
    rating: 5
  },
  {
    id: 2,
    name: 'Maya R.',
    role: 'College Freshman',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c63a8288-1763296861138.png",
    avatarAlt: 'Professional headshot of young female student with warm smile and professional attire',
    content: 'The pronunciation guides are a game-changer! I can finally speak Shakespeare\'s lines with confidence. The audio recordings by professional actors helped me nail my drama audition. Absolutely worth it!',
    rating: 5
  },
  {
    id: 3,
    name: 'Jordan K.',
    role: 'AP Literature Student',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1e7b4c55e-1763292854026.png",
    avatarAlt: 'Professional headshot of male student with glasses showing enthusiasm and energy',
    content: 'I was struggling to keep up with my AP Lit class until I found BardPlay. The interactive quizzes and instant feedback helped me master complex themes quickly. Got a 5 on my AP exam!',
    rating: 5
  }];


  return (
    <section className="py-24 lg:py-32 relative">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            Students Are <span className="gradient-text">Loving It!</span>
          </h2>
          <p className="text-base sm:text-lg text-white/70 max-w-3xl mx-auto">
            See what users are saying about their BardPlay transformation
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="modern-card hover:scale-105 transition-transform duration-300">

              <div className="flex gap-1 mb-4">
                {[...Array(5)]?.map((_, i) =>
              <Icon key={i} name="Star" size={18} className="text-yellow-400 fill-current" />
              )}
              </div>

              <p className="text-white/80 leading-relaxed mb-6 text-base">
                "{testimonial?.content}"
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-white/10">
                <img
                src={testimonial?.avatar}
                alt={testimonial?.avatarAlt}
                className="w-12 h-12 rounded-full object-cover" />

                <div>
                  <p className="text-white font-semibold">{testimonial?.name}</p>
                  <p className="text-white/60 text-sm">{testimonial?.role}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;